module.exports = __webpack_public_path__ + "static/image-35c3691ed58f372d1898bda8baac0185.jpg";